<template>
  <div class="specs-list space-y-1.5" @mousemove="mouseOn" @touchmove="touchOn" @mouseup="flag = null"
       @mouseleave="flag = null" @touchend="flag = null">
    <div class="grid grid-cols-2 gap-2 mt-2">
      <div class="col-span-2 range-slider relative h-2 cursor-pointer" ref="slider" @mousedown="mouseStart"
           @mouseup="flag = null" @touchstart="touchStart" @touchend="flag = null">
        <div class="slider-track transition-all duration-150"
             :style="{background: computed_background}"></div>
        <input type="range" ref="minRange" :min="min" :max="max" step="1"
               class="custom-range transition-all duration-150"
               v-model="sliderMin">
        <input type="range" ref="maxRange" :min="min" :max="max" step="1"
               class="custom-range transition-all duration-150"
               v-model="sliderMax">
      </div>
      <div class="border-[1px] border-gray-light flex items-center space-x-1 rounded p-1">
        <input type="number" :min="min" :max="max" step="1"
               class="grow ring-0 focus:ring-0 h-auto p-0 bg-transparent placeholder-muted" v-model="sliderMin"
               :placeholder="min">
        <span class="text-muted select-none">{{ spec.unit_of_measure }}</span>
      </div>
      <div class="border-[1px] border-gray-light flex items-center space-x-1 rounded p-1">
        <input type="number" :min="min" :max="max" step="1"
               class="grow ring-0 focus:ring-0 h-auto p-0 bg-transparent placeholder-muted" v-model="sliderMax"
               :placeholder="max">
        <span class="text-muted select-none">{{ spec.unit_of_measure }}</span>
      </div>
    </div>
    <div class="flex">
      <button
          class="btn font-normal border-thin border-gray-light bg-gray-lighter hover:bg-secondary-light hover:border-none h-4 w-full rounded-lg"
          @click="submit()">Applica
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "range",
  props: ['spec', 'changeSpecs', 'loading', 'selected_specs', 'getSpec'],
  data: () => ({
    show: false,
    minAngle: 0,
    maxAngle: 100,
    min: 0,
    max: 100,
    miniGap: 0,
    flag: null,
    searched: {
      min: null,
      max: null
    },
  }),
  methods: {
    touchOn(event) {
      if (this.flag) this.changeSlider(event.changedTouches[0].clientX)
    },
    touchStart(event) {
      this.flag = true;
      this.touchOn(event);
    },
    mouseOn(event) {
      if (this.flag) this.changeSlider(event.clientX)
    },
    mouseStart(event) {
      this.flag = true;
      this.mouseOn(event);
    },
    changeSlider(x) {
      let rect = this.$refs.slider.getBoundingClientRect();
      const minAngleX = (((this.minAngle - this.min) / (this.max - this.min)) * ((rect.width - 8) - 8)) + 8 + rect.left; /* 8 = 8px = 0.5em = thumbWidth/2 */
      const maxAngleX = (((this.maxAngle - this.min) / (this.max - this.min)) * ((rect.width - 8) - 8)) + 8 + rect.left; /* 8 = 8px = 0.5em = thumbWidth/2 */
      let props = Math.max(Math.floor(this.max / rect.width * (x - rect.left)), this.min);
      if (this.flag !== 'min' && this.flag !== 'max')
        if (Math.abs(x - minAngleX) < Math.abs(x - maxAngleX)) this.flag = 'min';
        else this.flag = 'max';
      if (this.flag === 'min') this.sliderMin = props;
      else this.sliderMax = props;
    },
    submit() {
      if (this.maxAngle < 0 || isNaN(this.maxAngle)) this.maxAngle = this.max;
      if (this.minAngle < 0 || isNaN(this.minAngle)) this.minAngle = this.min;
      if ((this.minAngle != null && this.maxAngle != null) && (this.maxAngle < this.minAngle)) {
        let tmp = this.minAngle;
        this.minAngle = this.maxAngle;
        this.maxAngle = tmp;
      }
      if (!(this.maxAngle >= this.max && this.minAngle <= this.min)) {
        this.searched.min = this.minAngle;
        this.searched.max = this.maxAngle;
      }
      this.changeSpecs(this.spec.id, this.searched);
    },
    filter(a) {
      this.searched.min = a.min;
      this.searched.max = a.max;
      this.submit();
    }
  },
  mounted() {
    this.min = this.$props.spec.values.min;
    this.max = this.$props.spec.values.max;
    let tmp = this.selected_specs && this.selected_specs[this.spec.id] && this.selected_specs[this.spec.id].min ? parseInt(this.selected_specs[this.spec.id].min, this.$props.spec.id) : 0;
    this.minAngle = Math.max(this.min, tmp);
    console.log(this.minAngle);
    tmp = this.selected_specs && this.selected_specs[this.spec.id] && this.selected_specs[this.spec.id].max ? parseInt(this.selected_specs[this.spec.id].max, this.$props.spec.id) : 0;
    this.maxAngle = Math.min(parseInt(tmp, this.$props.spec.id) || this.max, this.max);
    console.log(this.maxAngle);
    this.miniGap = Math.ceil(this.max / 100 * 10)
    this.$forceUpdate();
  },
  computed: {
    computed_background() {
      let percent1 = (Math.max(this.minAngle, this.min) / this.max) * 100;
      let percent2 = (Math.min(this.maxAngle, this.max) / this.max) * 100;
      return `linear-gradient(to right, #dadae5 ${percent1}% , #00283a ${percent1}% , #00283a ${percent2}%, #dadae5 ${percent2}%)`;
    },
    sliderMin: {
      get: function () {
        return parseInt(this.minAngle);
      },
      set: function (val) {
        if (val)
          val = parseInt(val);
        else val = 0;
        if (val > this.maxAngle) {
          this.maxAngle = Math.min(val, this.max);
        }
        this.minAngle = Math.min(val, this.max);
      }
    },
    sliderMax: {
      get: function () {
        return parseInt(this.maxAngle);
      },
      set: function (val) {
        if (val)
          val = parseInt(val);
        else val = 0;
        if (val < this.minAngle) {
          this.minAngle = val;
        }
        this.maxAngle = Math.min(val, this.max);
      }
    },
  },
}
</script>
<style>
.custom-range {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 100%;
  outline: none;
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  background-color: transparent;
  pointer-events: none;
  cursor: pointer;
  transition: opacity .2s;
}

.slider-track {
  width: 100%;
  height: 5px;
  position: absolute;
  margin: auto;
  left: 0;
  bottom: 0;
  top: 0;
  right: 0;
  border-radius: 5px;
  transition: opacity .2s;
  cursor: pointer;
}

.custom-range::-webkit-slider-runnable-track {
  -webkit-appearance: none;
  height: 2px;
  transition: opacity .2s;
}

.custom-range::-moz-range-track {
  -moz-appearance: none;
  height: 2px;
  transition: opacity .2s;
}

.custom-range::-ms-track {
  appearance: none;
  height: 2px;
  transition: opacity .2s;
}

.custom-range::-webkit-slider-thumb {
  -webkit-appearance: none;
  height: 1em;
  width: 1em;
  background-color: #00283a;
  cursor: pointer;
  margin-top: -0.5em;
  pointer-events: auto;
  border-radius: 50%;
  transition: opacity .2s;
}

.custom-range::-moz-range-thumb {
  -webkit-appearance: none;
  height: 1em;
  width: 1em;
  cursor: pointer;
  border-radius: 50%;
  background-color: #00283a;
  pointer-events: auto;
  border: none;
  transition: opacity .2s;
}

.custom-range::-ms-thumb {
  appearance: none;
  height: 1em;
  width: 1em;
  cursor: pointer;
  border-radius: 50%;
  background-color: #00283a;
  pointer-events: auto;
  transition: opacity .2s;
}

.custom-range:active::-webkit-slider-thumb {
  background-color: #003245;
  border: 1px solid #003245;
  transition: opacity .2s;
}

</style>